module.exports = __webpack_public_path__ + "img/route-node.bdb3e561.svg";